// Design System — the aria-describedby wiring shared by the form controls.
//
// A control that sets `aria-invalid` without pointing at the message tells a
// screen-reader user the field is wrong and never what is wrong with it. The
// ids have to agree between the control and the <div> that renders the text,
// so both sides read them from here rather than each composing its own.
//
// Error and helper text are mutually exclusive by design — the error replaces
// the hint — so at most one id is ever produced.

export const describeField = (controlId, { errorText, helperText } = {}) => {
    const errorId = errorText ? `${controlId}-error` : null;
    const helperId = !errorText && helperText ? `${controlId}-help` : null;
    return { errorId, helperId, describedBy: errorId || helperId || undefined };
};

export default describeField;
